export var HIGHLIGHT_PATTERN = /@hlword@(.*?)@\/hlword@/g;
export var SCOPES = ['all', 'wiki', 'people', 'issues', 'doc', 'atushka', 'map', 'services', 'goals', 'calendar', 'ml', 'stackoverflow', 'help'];
export var SCOPES_INTERNAL_NET = ['all', 'wiki', 'people', 'issues', 'map', 'goals', 'calendar', 'ml', 'stackoverflow', 'help'];
export var SCOPES_WITH_NPM = [].concat(SCOPES).splice(0, SCOPES.length - 1).concat('npm', SCOPES[SCOPES.length - 1]);
export var SCOPES_WITH_CHAT = SCOPES_WITH_NPM.concat('chat');
export var BASE_URL = 'https://search.yandex-team.ru/';
export var SUGGEST_BASE_URL = "".concat(BASE_URL, "suggest/");
export var MARKS_BASE_URL = "".concat(BASE_URL, "api/v1/marks/");
export var INPUT_BORDER_WIDTH = 1;
export var SEARCH_PAGE_FOR_SCOPE = {
  all: '',
  wiki: 'wiki',
  people: 'people',
  issues: 'st',
  doc: 'doc',
  atushka: 'at',
  map: 'map',
  services: 'abc',
  goals: 'goal',
  calendar: 'calendar',
  ml: 'ml',
  stackoverflow: 'stackoverflow',
  npm: 'npm',
  help: 'help',
  chat: 'chat'
};
export var METRIKA_ID = '1028202';
// #sourceMappingURL=constants.js.map